import './Footer.css'
import { content } from '../../data/siteData'
import { Link } from 'react-router-dom'
import largeLogo from '../../resources/images/large_logo_no_purple_square.png';
import SiteContentBlocks from '../SiteContentBlocks/SiteContentBlocks'

const renderStaticContent = (fieldPath, label, children) => children;

export default function Footer ({
    footerContent = content.home.header,
    renderEditableContent = renderStaticContent
}) {
    return (
        <div className='footer footer_color'>
                <div className='title_container footer_color' >
                <div className='logo footer_color'>
                    <img 
                        alt='purple flower logo' 
                        src={ largeLogo }
                    />
                    </div>
                    <div className='title footer_color'>
                        <h1 className='footer_color'>
                            { renderEditableContent('header.title', 'Footer title', footerContent.title) }
                        </h1>
                        <p className='footer_color'>
                            { renderEditableContent('header.subtitle', 'Footer subtitle', footerContent.subtitle) }
                        </p>
                        <SiteContentBlocks
                            blocks={footerContent.contentBlocks}
                            fieldPathPrefix="header.contentBlocks"
                            labelPrefix="Footer"
                            renderEditableContent={renderEditableContent}
                            variant="footer"
                        />
                    </div>
                    
                </div>
                <div className='get_in_touch_footer footer_color'>
                    <Link to="/contact">
                        <button>{ footerContent.button }</button>
                    </Link>

                </div>
            </div>
    )
}
